import { jsx } from "react/jsx-runtime";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { validateTidalLicense } from "../../base/index.js";
function FilterAlt(props) {
  return /* @__PURE__ */ jsx(
    FilterAltIcon,
    {
      "data-testid": "FilterAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FilterAlt",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
FilterAlt.tidalIconMeta = {
  categories: "common,navigation",
  name: "FilterAlt"
};
validateTidalLicense();
export {
  FilterAlt
};
//# sourceMappingURL=FilterAlt.js.map
